const getAutoSuggestPublicResultsQuery = /* GraphQL */ `
  query GetAutoSuggestPublicResults($autoSuggestRequest: AutoSuggestPublicRequestInput) {
    autoSuggestPublic(autoSuggestPublicRequest: $autoSuggestRequest) {
      autoSuggestProducts {
        position
        price
        url
        skuBaseNumber
        title
        thumbImageUrl
        publicSkuBaseDetails {
          availability
          reviewCount
          rating
          segmentCategorization
          superMarketAffinity
          brand
        }
      }
      autoSuggestArticles {
        position
        url
        title
        thumbImageUrl
      }
      categoryLinks {
        url
        name
      }
      typeAheadSuggestion
      productQuery
      suggestedQueries {
        ordinality
        query
        queryWithMarkups
      }
    }
  }
`

export default getAutoSuggestPublicResultsQuery
